import React from "react"
import { Link } from "react-router-dom"

import { areaTitle } from "./helpUtils"

import "./HelpBreadcrumbs.scss"

export default function HelpBreadcrumbs({ area, slug, sitemap }) {
  const pageEntry = sitemap.find((e) => e.area === area && e.slug === slug)
  const pageTitle = pageEntry?.title || slug

  return (
    <nav className="HelpBreadcrumbs" aria-label="Breadcrumb">
      <Link to="/help">Help</Link>
      <span className="HelpBreadcrumbs-sep">/</span>
      <Link to={`/help/${area}`}>{areaTitle(area)}</Link>
      <span className="HelpBreadcrumbs-sep">/</span>
      <span className="HelpBreadcrumbs-current">{pageTitle}</span>
    </nav>
  )
}
